import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input, OnChanges, SimpleChanges } from '@angular/core';

import { IconComponent, TooltipDirective } from '@mode/capra';
import { ReportTypes } from '@mode/shared/contract-common';

@Component({
  standalone: true,
  selector: 'mode-publish-badge-icon',
  imports: [CommonModule, IconComponent, TooltipDirective],
  templateUrl: './publish-badge-icon.component.html',
  styleUrls: ['./publish-badge-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublishBadgeIconComponent implements OnChanges {
  @Input() type: ReportTypes.ReportType = ReportTypes.ReportType.Report;
  tooltipContent = '';
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['type'] && changes['type'].currentValue) {
      const isDatasetReport = changes['type'].currentValue === ReportTypes.ReportType.DatasetReport;
      this.tooltipContent = isDatasetReport
        ? 'This Dataset is published as a table in the Data Workspace'
        : 'This Report contains a Python dataset that is published as a table in the Data Workspace';
    }
  }
}
